/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UnitDistanceFromJSON, UnitDistanceToJSON, } from "./UnitDistance";
/**
 * Check if a given object implements the Option1UnitDistance interface.
 */
export function instanceOfOption1UnitDistance(value) {
    let isInstance = true;
    isInstance = isInstance && "value" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    return isInstance;
}
export function Option1UnitDistanceFromJSON(json) {
    return Option1UnitDistanceFromJSONTyped(json, false);
}
export function Option1UnitDistanceFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        value: UnitDistanceFromJSON(json.value),
        name: json.name,
        description: json.description,
    };
}
export function Option1UnitDistanceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        value: UnitDistanceToJSON(value.value),
        name: value.name,
        description: value.description,
    };
}
